import React from "react"
import { Route, Redirect } from "react-router-dom"
import Auth from "./Auth"

class UserRoute extends React.Component {
    state = {
        auth: false,
        loading: true,
        error: "",
    }

    async componentDidMount() {
        const response = await Auth.tokenCheck()
        if (response.authenticated) {
            this.setState({ auth: true })
        }
        this.setState({ error: response.error })
        this.setState({ loading: false })
    }

    render() {
        const { loading, auth } = this.state
        if (!loading && !auth) {
            // if (this.props.path === "/") {
            //     return (
            //         <Redirect
            //             to={{
            //                 pathname: "/login",
            //             }}
            //         />
            //     )
            // } else {
            //     return (
            //         <Redirect
            //             to={{
            //                 pathname: "/RegisterOption",
            //                 state: {
            //                     error: this.state.error,
            //                 },
            //             }}
            //         />
            //     )
            // }
            return (
                <Redirect
                    to={{
                        pathname: "/login",
                        state: {
                            error: this.state.error,
                        }
                    }}
                />
            )
        } else {
            return (
                !loading && (
                    (this.props.component) ?
                        <Route
                            exact={this.props.exact}
                            path={this.props.path}
                            component={this.props.component}
                        /> :
                        <Route
                            exact={this.props.exact}
                            path={this.props.path}
                            render={this.props.render}
                        />
                )
            )
        }
    }
}

export default UserRoute
